import React, { FormEvent, useState, useEffect, useRef } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import InputField from "../../components/InputField/InputField";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import "./trainingform.css";
import { HiArrowSmallLeft } from "react-icons/hi2";
import { Button } from "react-bootstrap";
import { postDetails, postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import CustomMultiSelectDropdown from "../../components/CustomMultiSelectDropdown/CustomMultiSelectDropdown";
import encrypt from "../../utils/helpers/encrypt";
import formatDate from "../../utils/helpers/formatDate";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { log } from "console";

interface TrainingFormProps {
  initialValues?: {
    all_employee: number;
    id?: number;
    name?: string;
    coverImage?: File | null;
    description?: string;
    groupsOrEmployees?: { id: number; name: string }[];
    allowMultipleAccess?: boolean;
    addAllEmployees?: boolean;
    externalTrainingLink?: string;
    closeDate?: string;
    is_priority?: string;
    isExternalLinkEnabled?: boolean;
    selectedQuiz?: { id: number; name: string };
    selectedModule?: { id: number; name: string };
  };
}


const EditTrainingForm: React.FunctionComponent<TrainingFormProps> = ({
  initialValues,
}) => {

  const isUIMounted = useRef(false)
  const [groupData, setGroupData] = useState<any>([])
  const [data, setData] = useState<{ id: number; name: string }[]>([]);
  const [searchMaster, setSearchMaster] = useState<{ id: number; name: string }[]>([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showCropper, setShowCropper] = useState<boolean>(false);
  const [imageSrc, setImageSrc] = useState<string>("");

  const [employeeSelection, setEmployeeSelection] = useState<{
    name: string;

  }>({ name: 'All Employee' });

  const dispatch = useAppDispatch();
  const [trainingDetails, setTrainingDetails] = useState({
    name: "",
    coverImage: null as File | null,
    description: "",
    groupsOrEmployees: [] as { id: number, name: string }[],
    allowMultipleAccess: false,
    addAllEmployees: false,
    externalTrainingLink: "",
    closeDate: "",
    selectedQuiz: { id: 0, name: "" },
    selectedModule: { id: 0, name: "" },
    is_priority: "",
    isExternalLinkEnabled: false,
    all_employee: 0,
  });
  const [originalTrainingDetails, setOriginalTrainingDetails] = useState(trainingDetails);
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedValue, setSelectedValue] = useState<any[]>([])

  const [selectedCloseDate, setSelectedCloseDate] = useState<Date | null>(null)

  //* For selected options inside dropdown
  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  // Fetch people once on mount
  const fetchPeople = async () => {
    try {
      const response = await postDetails(APIList.GET_ALL_PEOPLE, {});
      setData(response.data);
      setSearchMaster(response.data)
    } catch (error) {
      console.error("Failed to fetch people:", error);
    }
  };
  const fetchGroupData = async () => {
    try {
      const response = await postDetails(APIList.GET_ALL_GROUPS, {});
      setGroupData(response.data);
      setSearchMaster(response.data)
    } catch (error) {
      console.error("Failed to fetch group data:", error);
      return [];
    }
  };

  // const fetchTrainingDetails = async (trainingId: number) => {
  //   try {
  //     dispatch(showLoader("Loading Data..."));
  //     const response = await postDetails(APIList.GET_TRAINING_MASTER_BY_ID, {
  //       training_id: trainingId,
  //     });

  //     if (response.data) {
  //       const details = response.data;
  //       const cleanedCoverImage = details.cover_img ? details.cover_img.replace(/;;+$/, '') : '';
  //       const formattedCloseDate = details.closeDate
  //         ? formatDate(details.closeDate, "yyyy-mm-dd")
  //         : "";
  //       const mappedGroupsOrEmployees =
  //         details.training_assign?.map((id: number) => {
  //           const foundPerson = data.find((person) => person.id === id);
  //           return {
  //             id,
  //             name: foundPerson ? foundPerson.name : "",
  //           };
  //         }) || [];

  //       let employeeSelection = "Individual Employee";
  //       if (details.all_employee === 1) {
  //         employeeSelection = "All Employees";
  //       } else if (details.all_employee === 2) {
  //         employeeSelection = "Group";
  //       }

  //       setTrainingDetails({
  //         name: details.name || "",
  //         coverImage: cleanedCoverImage || null,
  //         description: details.description || "",
  //         groupsOrEmployees: mappedGroupsOrEmployees,
  //         allowMultipleAccess: details.multiple_attempts === 1,
  //         addAllEmployees: details.addAllEmployees || false,
  //         externalTrainingLink: details.external_link || "",
  //         closeDate: formattedCloseDate,
  //         is_priority: details.is_priority === 1 ? "1" : "",
  //         isExternalLinkEnabled: !!details.external_link,
  //         selectedQuiz: details.selectedQuiz || { id: 0, name: "" },
  //         selectedModule: details.selectedModule || { id: 0, name: "" },
  //         all_employee: details.all_employee || 0,
  //       });

  //       // Update originalTrainingDetails after fetching
  //       setOriginalTrainingDetails({
  //         name: details.name || "",
  //         coverImage: cleanedCoverImage || null,
  //         description: details.description || "",
  //         groupsOrEmployees: mappedGroupsOrEmployees,
  //         allowMultipleAccess: details.multiple_attempts === 1,
  //         addAllEmployees: details.addAllEmployees || false,
  //         externalTrainingLink: details.external_link || "",
  //         closeDate: formattedCloseDate,
  //         is_priority: details.is_priority === 1 ? "1" : "",
  //         isExternalLinkEnabled: !!details.external_link,
  //         selectedQuiz: details.selectedQuiz || { id: 0, name: "" },
  //         selectedModule: details.selectedModule || { id: 0, name: "" },
  //         all_employee: details.all_employee || 0,
  //       });

  //       setSelectedValue(details.training_assign);
  //       setEmployeeSelection({ name: employeeSelection });
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch training details:", error);
  //   } finally {
  //     dispatch(hideLoader());
  //   }
  // };

  const fetchTrainingDetails = async (trainingId: number) => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_TRAINING_MASTER_BY_ID, {
        training_id: trainingId,
      });

      if (response.data) {
        console.log("RESPONSE", response.data)
        const details = response.data;
        const cleanedCoverImage = details.cover_img ? details.cover_img.replace(/;;+$/, '') : '';
        const formattedCloseDate = details.closeDate
          ? formatDate(details.closeDate, "yyyy-mm-dd")
          : "";

        let mappedGroupsOrEmployees = [];

        if (details.all_employee === 2) {
          mappedGroupsOrEmployees = details.training_assign?.map((id: number) => {
            const groups = data.find((group) => group.id === id); // Fetch only selected groups
            return {
              id,
              name: groups ? groups.name : "",
            }
          }) || [];;
        } else {
          mappedGroupsOrEmployees = details.training_assign?.map((id: number) => {
            const foundPerson = data.find((person) => person.id === id);
            return {
              id,
              name: foundPerson ? foundPerson.name : "",
            };
          }) || [];
        }

        let employeeSelection = "Individual Employee";
        if (details.all_employee === 1) {
          employeeSelection = "All Employees";
        } else if (details.all_employee === 2) {
          employeeSelection = "Group";
        }

        const previouslySelectedOptions = response.data.training_assign.map((item: any) => ({
          value: item.id,
          label: item.name,
        }))
        // const previouslySelectedOptions = response.data.training_assign.map((item: any) => item.id);
        setSelectedOptions(previouslySelectedOptions)

        setTrainingDetails({
          name: details.name || "",
          coverImage: cleanedCoverImage || null,
          description: details.description || "",
          groupsOrEmployees: mappedGroupsOrEmployees,
          allowMultipleAccess: details.multiple_attempts === 1,
          addAllEmployees: details.addAllEmployees || false,
          externalTrainingLink: details.external_link || "",
          closeDate: formattedCloseDate,
          is_priority: details.is_priority === 1 ? "1" : "",
          isExternalLinkEnabled: !!details.external_link,
          selectedQuiz: details.selectedQuiz || { id: 0, name: "" },
          selectedModule: details.selectedModule || { id: 0, name: "" },
          all_employee: details.all_employee || 0,
        });


        // Update originalTrainingDetails after fetching
        setOriginalTrainingDetails({
          name: details.name || "",
          coverImage: cleanedCoverImage || null,
          description: details.description || "",
          groupsOrEmployees: mappedGroupsOrEmployees,
          allowMultipleAccess: details.multiple_attempts === 1,
          addAllEmployees: details.addAllEmployees || false,
          externalTrainingLink: details.external_link || "",
          closeDate: formattedCloseDate,
          is_priority: details.is_priority === 1 ? "1" : "",
          isExternalLinkEnabled: !!details.external_link,
          selectedQuiz: details.selectedQuiz || { id: 0, name: "" },
          selectedModule: details.selectedModule || { id: 0, name: "" },
          all_employee: details.all_employee || 0,
        });

        setSelectedValue(details.training_assign);
        setEmployeeSelection({ name: employeeSelection });
        setSelectedCloseDate(details.closeDate
          ? new Date(details.closeDate)
          : null)
      }
    } catch (error) {
      console.error("Failed to fetch training details:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    console.log('use Effect Called 1');
    if (isUIMounted.current) return;
    isUIMounted.current = true;
    fetchGroupData();
    fetchPeople();

    if (id) {
      fetchTrainingDetails(Number(id));
    } else if (initialValues) {
      let employeeSelection = "Individual Employee";
      if (initialValues.all_employee === 1) {
        employeeSelection = "All Employees";
      } else if (initialValues.all_employee === 2) {
        employeeSelection = "Group";
      }

      const mappedGroupsOrEmployees = initialValues.groupsOrEmployees?.map((groupOrEmployee) => {
        const foundPerson = data.find((person) => person.id === groupOrEmployee.id);

        const foundGroup = groupData.find((group: { id: number; }) => group.id === groupOrEmployee.id);

        return {
          id: groupOrEmployee.id,
          name: foundPerson ? foundPerson.name : foundGroup ? foundGroup.name : groupOrEmployee.name,
        };
      }) || [];

      setTrainingDetails((prev) => ({
        ...prev,
        ...initialValues,
        groupsOrEmployees: mappedGroupsOrEmployees,
      }));

      setOriginalTrainingDetails(trainingDetails);
      setEmployeeSelection({ name: employeeSelection });
    }
  }, [trainingDetails, data, groupData]); // Add groupsData as a dependency




  const formatDateForInput = (date: string) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${day}-${month}-${year}`;


  };

  const handleFileChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files } = ev.target;
    if (name === "coverImage" && files && files[0]) {
      const selectedFile = files[0];

      const validation = validateImageFile(selectedFile);
      if (!validation.valid) {
        dispatch(showToast(validation.message));
        setTimeout(() => dispatch(hideToast()), 3000);
        ev.target.value = "";
        return;
      }

      setTrainingDetails((prev) => ({
        ...prev,
        coverImage: selectedFile,
      }));

      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result as string);
        setShowCropper(true);
      };
      reader.readAsDataURL(selectedFile);
    }
  };



  const coverImagePreview = () => {
    if (trainingDetails.coverImage instanceof File) {
      try {
        return URL.createObjectURL(trainingDetails.coverImage);
      } catch (error) {
        console.error("Failed to create object URL:", error);
        return "";
      }
    } else if (typeof trainingDetails.coverImage === 'string') {

      return trainingDetails.coverImage;
    }
    return "";
  };

  const formatDateForSaving = (date: string) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;

  };

  const handleInputChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = ev.target;
    const isCheckbox = type === "checkbox";
    const isChecked = isCheckbox
      ? (ev.target as HTMLInputElement).checked
      : false;

    console.log(`Field changed: ${name}, Value: ${isCheckbox ? isChecked : value}`);

    if (name === "addAllEmployees") {
      setTrainingDetails((prev) => ({
        ...prev,
        addAllEmployees: isChecked,
        groupsOrEmployees: isChecked ? data : [],
      }));
    } else if (name === "is_priority") {
      setTrainingDetails((prev) => ({
        ...prev,
        is_priority: isChecked ? "1" : "",
      }));
    } else if (name === "externalTrainingLink" && !isCheckbox) {
      setTrainingDetails((prev) => ({
        ...prev,
        externalTrainingLink: value,
      }));
    } else if (name === "closeDate") {
      setTrainingDetails((prev) => ({
        ...prev,
        closeDate: value ? formatDateForInput(value) : "",
      }));
    } else {
      setTrainingDetails((prev) => ({
        ...prev,
        [name]: isCheckbox ? isChecked : value,
      }));
    }
  };

  const handleCheckboxChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = ev.target;
    console.log(`Checkbox changed: ${name}, Checked: ${checked}`);
    if (name === "externalTrainingLink") {
      setTrainingDetails((prev) => ({
        ...prev,
        externalTrainingLink: checked
          ? prev.externalTrainingLink
          : "",
        isExternalLinkEnabled: checked,
      }));
    } else {
      setTrainingDetails((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }
  };

  console.log("OPTIONS SLECTED already SELECt", selectedOptions);

  const handleSelectChange = (selectedOptions: any) => {
    const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : selectedOptions ? [selectedOptions] : [];
    console.log("OPTIONS SLECTED WITH REACT SELECt", selectedOptions);
    setSelectedOptions(selectedOptions)
    setTrainingDetails({
      ...trainingDetails,
      groupsOrEmployees: selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      })),
    });
  };

  const handleSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    const traineeIds =
      trainingDetails.all_employee === 1
        ? data.map((employee) => employee.id)
        : trainingDetails.groupsOrEmployees.map((item: any) => item['id']);

    // const formattedCloseDate = formatDateForSaving(trainingDetails.closeDate);

    const formData = new FormData();
    //   {
    //     "id": 25049,
    //     "name": "Arock Asmadiya"
    // }
    // console.log(traineeIds.map((ids: any) => {
    //   console.log(ids);
    //   return typeof ids === 'object' ? ids.id : ids
    // }))
    const formattedData = {
      id: Number(id),
      name: trainingDetails.name,
      description: trainingDetails.description,
      trainee_ids: traineeIds.map((ids: any) => {
        console.log(ids);
        return typeof ids === 'object' ? ids.id : ids
      }),
      is_priority: trainingDetails.is_priority !== "" ? 1 : 0,
      multiple_attempts: trainingDetails.allowMultipleAccess ? 1 : 0,
      external_link: trainingDetails.isExternalLinkEnabled && trainingDetails.externalTrainingLink ? trainingDetails.externalTrainingLink : "",
      // closeDate:formattedCloseDate || "",
      closeDate: trainingDetails.closeDate,
      all_employee: trainingDetails.all_employee,
    }
    const hasChanged = JSON.stringify(originalTrainingDetails) !== JSON.stringify(trainingDetails);

    if (!hasChanged) {
      dispatch(showToast("No Changes Done"));
      setTimeout(() => dispatch(hideToast()), 3000)
      return;
    }
    if (trainingDetails.coverImage) {
      formData.append("cover_img", trainingDetails.coverImage);
    }
    formData.append("data", encrypt(formattedData))
    try {
      const response = await postMultipartDetails(APIList.EDIT_TRAINING, formData);

      if (response.status === 200) {
        navigate("/trainings", {
          state: { isExternalLinkEnabled: trainingDetails.isExternalLinkEnabled },
        });
      }
      else {
        // dispatch(showToast("Heyyy"));
        // setTimeout(()=>dispatch(hideToast()),3000)
        navigate("/trainings", {
          state: { isExternalLinkEnabled: trainingDetails.isExternalLinkEnabled },
        });
      }

    } catch (error) {
      console.error("Failed to submit training details:", error);
    }
  };

  const handleCrop = (croppedImageDataURL: string) => {
    fetch(croppedImageDataURL)
      .then(res => res.blob())
      .then(blob => {
        const croppedFile = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });

        setTrainingDetails(prev => ({
          ...prev,
          coverImage: croppedFile,
        }));

        setImageSrc(croppedImageDataURL); // Update image source for preview if needed
        setShowCropper(false); // Close the cropper modal
      })
      .catch(err => console.error("Error converting cropped image to blob:", err));
  };

  const handleCloseDateChange = (date: Date | null) => {
    setSelectedCloseDate(date);
    if (date) {
      setTrainingDetails((prevValue: any) => ({
        ...prevValue,
        closeDate: format(date, 'yyyy-MM-dd')
      }))
    }
    else {
      setTrainingDetails((prevValue: any) => ({
        ...prevValue,
        closeDate: ""
      }))
    }
  };

  const dropdownOptions = [
    { id: 1, value: "Individual Employee", label: "Individual Employee" },
    { id: 2, value: "All Employees", label: "All Employees" },
    { id: 3, value: "Group", label: "Group" },
  ];

  const handleClick = (ev: any, item: { id: number; name: string; value: number }) => {
    console.log(ev, item)
    const selectedValue: any = item.value;
    setEmployeeSelection({ name: selectedValue });
    if (selectedValue === "All Employees") {
      setTrainingDetails((prev) => ({
        ...prev,
        all_employee: 1,
        groupsOrEmployees: [],
      }));
    }
    else if (selectedValue === "Group") {
      setTrainingDetails((prev) => ({
        ...prev,
        all_employee: 2,
      }));
    } else {
      setTrainingDetails((prev) => ({
        ...prev,
        all_employee: 0,
      }));
    }
  };
  // const handleFileChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, files } = ev.target;
  //   if (name === "coverImage" && files && files[0]) {
  //     setTrainingDetails((prev) => ({
  //       ...prev,
  //       coverImage: files[0], // Store the selected file
  //     }));
  //   }
  // };


  const buttons = [
    {
      label: "Back to Training",
      theme: "danger",
      icon: <HiArrowSmallLeft />,
      onClick: () => navigate("/trainings"),
    },
  ];

  const options = data.map((item) => ({ value: item.id, label: item.name }));

  return (
    <LayoutContainer title={id ? "Edit Training" : "Add Training"}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-plus"></i>
          {id ? "Edit Training" : "Create Training"}
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      <div className="main-training">
        <form onSubmit={handleSubmit}>
          <div className="training-form">
            <div className="nameTraining">
              <label htmlFor="nameOfTraining">Name of Training <span style={{ color: 'red' }}>*</span></label>
              <InputField
                name="name"
                id="nameOfTraining"
                type="text"
                placeholder="Enter Name of Training"
                value={trainingDetails.name}
                onChangeInput={handleInputChange}
                required={true}
              />
            </div>

            <div className="training-image">
              <label htmlFor="coverImage">Choose Cover Image <span style={{ color: 'red' }}>*</span></label>
              <input
                type="file"
                name="coverImage"
                id="coverImage"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
                placeholder="hello"
              />
              {trainingDetails.coverImage && (
                <img
                  src={coverImagePreview()}
                  alt="Cover Preview"
                  className="cover-image-preview"
                />
              )}
            </div>
            <div className="desc">
              <label htmlFor="description">Add Description:<span style={{ color: 'red' }}>*</span></label>
              {/* <textarea
                name="description"
                id="description"
                placeholder="Add Description"
                value={trainingDetails.description}
                onChange={handleInputChange}
                required={true}
              /> */}


              <textarea
                name="description"
                value={trainingDetails.description}
                placeholder="Enter Description"
                maxLength={500}
                required={true}
                onChange={handleInputChange}
                rows={5}
                className="description-box"
              />
              <div className="character-coun">
                {(trainingDetails.description).length}/{500}
              </div>
            </div>


            <div className="close-date">
              <label htmlFor="closeDate">Close Date:<span style={{ color: 'red' }}>*</span></label>
              {/* <input
                type="date"
                name="closeDate"
                id="closeDate"
                value={formatDateForInput(trainingDetails.closeDate)}
                onChange={handleInputChange}
                required={true}
              /> */}

              <DatePicker
                id="closeDate"
                name="closeDate"
                selected={selectedCloseDate}
                onChange={handleCloseDateChange}
                dateFormat="dd-MM-yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={new Date()}
                onKeyDown={(e: any) => { e.preventDefault() }}
                placeholderText="Close Date"
                className={`mf-admin-inputfield`}
                // onBlur={handleDatePickerOnBlur}
                // required={true}
                isClearable
              />

              {/* <InputField
                name="closeDate"
                label="closeDate"
                type="date"
                value={formatDateForInput(trainingDetails.closeDate)}
                placeholder="Enter Date"
                required={true}
                onChangeInput={handleInputChange}
              />*/}

            </div>

            <div className="employee-selection">
              <CustomDropdown
                currentValue={employeeSelection}
                menuItems={dropdownOptions}
                onClick={handleClick}
                label="Employee or All"
                menuItemKey="label"
                required={true}

                type={"Employee or All"}
              />
            </div>


            {trainingDetails.all_employee !== 1 && (
              <div className="group-employees">
                {/* <label htmlFor="groupsOrEmployees">
                  Add Group or Employees *
                </label> */}
                {/* <CustomMultiSelectDropdown
  currentValue={selectedValue}  
  menuItems={
    trainingDetails.all_employee === 2
      ? groupData
          .sort((a: any, b: any) => a.name.localeCompare(b.name))
          .map((item: { id: any; name: any }) => ({
            id: item.id,       
            name: item.name,  
            value: item.id,    
            label: item.name,  
          }))
      : data
          .sort((a: any, b: any) => a.name.localeCompare(b.name))
          .map((item: { id: any; name: any }) => ({
            id: item.id,     
            name: item.name,   
            value: item.id,  
            label: item.name,  
          }))
  }
  onClick={handleSelectChange}
  label="Add Employees to Group"
  menuItemKey="name"
  type="multiselect"
  multiSelect={true}
  
  searchMasterData={searchMaster}
  searchSetData={setData}
  searchable={true}
/> */}




                <Select
                  isMulti
                  name="groupsOrEmployees"
                  id="groupsOrEmployees"
                  value={selectedOptions}
                  options={
                    trainingDetails.all_employee === 2
                      ? groupData
                        .sort((a: any, b: any) => a.name.localeCompare(b.name))
                        .map((item: { id: any; name: any; }) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : data
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                  }
                  // value={trainingDetails.groupsOrEmployees.map((item) => ({
                  //   value: item.id,
                  //   label: item.name,
                  // }))}
                  onChange={handleSelectChange}
                  placeholder="Select Groups or Employees"
                />

              </div>
            )}
            {trainingDetails.isExternalLinkEnabled && (
              <div className="form-group">
                <InputField
                  label="External Training Link"
                  name="externalTrainingLink"
                  value={trainingDetails.externalTrainingLink}
                  onChangeInput={handleInputChange} type={""} />
              </div>
            )}

            <div className="check-one">
              <label>
                <input
                  type="checkbox"
                  name="is_priority"
                  checked={trainingDetails.is_priority !== ""}
                  onChange={handleCheckboxChange}
                />
                Is-Priority
              </label>
            </div>
          </div>
          <hr></hr>
          <div className="form-buttons">
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-training-submit text-white">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      <CroppingModal
        show={showCropper}
        handleClose={() => setShowCropper(false)}
        image={imageSrc || ""}
        onCrop={handleCrop}
      />
    </LayoutContainer>
  );
};

export default EditTrainingForm;